(() => {
    const init = () => {
        const FEATURED_PRODUCT_SELECTOR = '[data-featured-product-section]';
        const FEATURED_IMAGE_SELECTOR = '[data-featured-image]';
        const THUMBNAILS_SELECTOR = '[data-thumbnails] img[data-thumb-src]';

        const SWIPER_SELECTOR = '[data-swiper]';
        const NEXT_BUTTON_SELECTOR = '[data-next-swiper]';
        const PREV_BUTTON_SELECTOR = '[data-prev-swiper]';
        const CURR_IMAGE_NUMBER_SELECTOR = '[data-current-image-number]';
        
        var section = document.querySelector(FEATURED_PRODUCT_SELECTOR);
        var featured = section.querySelector(FEATURED_IMAGE_SELECTOR);
        section.querySelectorAll(THUMBNAILS_SELECTOR).forEach(function(img){
            img.addEventListener('click', function(){
                featured.src = img.getAttribute('data-thumb-src');
                // Toggle selected styles
                section.querySelectorAll(THUMBNAILS_SELECTOR).forEach(function(i){ i.classList.remove('selected'); });
                img.classList.add('selected');
            });
        });

        const swiperEl = section.querySelector(SWIPER_SELECTOR);
        const nextEl = section.querySelector(NEXT_BUTTON_SELECTOR);
        const prevEl = section.querySelector(PREV_BUTTON_SELECTOR);

        const currentElementDisplay = section.querySelector(CURR_IMAGE_NUMBER_SELECTOR);

        function updateCurrent(swiper) {
            currentElementDisplay.textContent = swiper.realIndex + 1;
        }

        const swiper = new Swiper(swiperEl, {
            loop: false,
            navigation: {
                addIcons: false,
                nextEl,
                prevEl,
            },
            pagination: false,
            slidesPerView: 1,
        });

        updateCurrent(swiper);
        swiper.on('slideChange', () => {
            updateCurrent(swiper);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
